@if (isVisible) {
  <div>
    <bn-web-ui-toast-component
      [config]="config"
      [customClass]="customClass"
      [externalLink]="externalLink"
      [headerIcon]="headerIcon"
      [headerIconStyle]="headerIconStyle"
      [title]="heading"
      [type]="severity"
      (disposeEvent)="hideAlert()">
      <ng-content />
      <ng-content
        content-after
        select="[content-after]" />
    </bn-web-ui-toast-component>
  </div>
}
